import css from 'styled-jsx/css';

const styles = css.global`body {
  -webkit-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased; /* Melhora a suavização no Mac */
  -moz-osx-font-smoothing: grayscale; /* Reduz o peso da fonte no Mac */
}

#perguntas .perguntas-contain {
  margin-bottom: 48px;
}

@media (min-width: 992px) {
#perguntas .perguntas-contain{
  margin-top: 112px;
  margin-bottom: 24px;
}

}
@media (min-width: 1280px) {
  .ctn-home-24 {
      padding-right: 0;
      padding-left: 0;
  }
}`;

export default styles;